export type CalendarIntegrationJobCategory = 'SURVEY' | 'MOVE';

export const getCalendarIntegrationJobCategoryLabel = (
  category: CalendarIntegrationJobCategory,
) => {
  switch (category) {
    case 'SURVEY':
      return 'Survey';
    case 'MOVE':
      return 'Move';
  }
};

export const CalendarIntegrationJobCategoryOptions: {
  label: string;
  value: CalendarIntegrationJobCategory;
}[] = [
  {
    label: 'Survey',
    value: 'SURVEY',
  },
  {
    label: 'Move',
    value: 'MOVE',
  },
];
